import React from 'react'
import './Menu.scss';
function Menu({menuOpen,setMenuOpen}) {
  return (
    <div className={"menu "+ (menuOpen && 'active')}>
        <ul>
            <li onClick={()=> setMenuOpen(false)}>
                <a href="#intro">Home</a>
            </li>
            <li onClick={()=> setMenuOpen(false)}>
                <a href="#portfolio">Portfolio</a>
            </li>
            <li onClick={()=> setMenuOpen(false)}>
                <a href="#skills">Skills</a>
            </li>
            <li onClick={()=> setMenuOpen(false)}>
                <a href="#resume">Resume&CV</a>
            </li>
            
        </ul>
    </div>
  )
}
 
export default Menu